var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "account-view" },
    [
      _c(_setup.EmailUpdateDialog, {
        attrs: { email: _setup.email },
        model: {
          value: _setup.showEmailChangeModal,
          callback: function ($$v) {
            _setup.showEmailChangeModal = $$v
          },
          expression: "showEmailChangeModal",
        },
      }),
      _vm._v(" "),
      _c(_setup.ChangePasswordDialog, {
        on: {
          "password-changed": function ($event) {
            return _setup.onPasswordChanged()
          },
        },
        model: {
          value: _setup.showPasswordChangeModal,
          callback: function ($$v) {
            _setup.showPasswordChangeModal = $$v
          },
          expression: "showPasswordChangeModal",
        },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Name Update",
            "modal-class": "vue-need-bootstrap",
            lazy: "",
            centered: "",
            "no-close-on-backdrop": "",
          },
          on: { ok: _setup.updateUserName },
          model: {
            value: _setup.showNameWarnModal,
            callback: function ($$v) {
              _setup.showNameWarnModal = $$v
            },
            expression: "showNameWarnModal",
          },
        },
        [
          _vm._v(
            "\n        As you have an old password, updating the account name will force a password reset, you WILL have to reset\n        your password through the email that will be sent to continue using your account.\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row content mt-4 mb-4" }, [
        _c(
          "div",
          { staticClass: "col-6 d-flex flex-wrap justify-content-center mb-3" },
          [
            _c(
              "b-card",
              {
                staticClass: "white-card card-with-input",
                attrs: { title: "Profile" },
              },
              [
                _c(
                  "b-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _setup.onProfileSubmit()
                      },
                    },
                  },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "username-input",
                          label: "Username",
                          "label-for": "username-input",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "username-input",
                            required: "",
                            readonly: "",
                          },
                          model: {
                            value: _setup.user.Username,
                            callback: function ($$v) {
                              _vm.$set(_setup.user, "Username", $$v)
                            },
                            expression: "user.Username",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "name-input",
                          label: "Name",
                          "label-for": "name-input",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "name-input",
                            placeholder: "Account name",
                            required: "",
                            trim: "",
                            disabled: _setup.savingName,
                          },
                          model: {
                            value: _setup.name,
                            callback: function ($$v) {
                              _setup.name = $$v
                            },
                            expression: "name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      _setup.LoaderBtn,
                      {
                        staticClass: "float-right",
                        attrs: {
                          type: "submit",
                          variant: "primary",
                          loading: _setup.savingName,
                          disabled: !_setup.modifiedName,
                          "loading-text": "Saving",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Save\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6 d-flex flex-wrap justify-content-center mb-3" },
          [
            _c(
              "b-card",
              {
                staticClass: "white-card card-with-input",
                attrs: { title: "Login" },
              },
              [
                _c(
                  "b-form",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "email-input",
                          label: "Email",
                          "label-for": "email-input",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "email-input",
                            type: "email",
                            required: "",
                            readonly: "",
                          },
                          model: {
                            value: _setup.email,
                            callback: function ($$v) {
                              _setup.email = $$v
                            },
                            expression: "email",
                          },
                        }),
                        _vm._v(" "),
                        _c("b-form-text", { staticClass: "text-right link" }, [
                          _c(
                            "a",
                            {
                              class: {
                                disabled:
                                  _setup.loadingEmail || _setup.email === null,
                              },
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  _setup.showEmailChangeModal = true
                                },
                              },
                            },
                            [_vm._v("Change email")]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "password-input",
                          label: "Password",
                          "label-for": "password-input",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "password-input",
                            type: "password",
                            value: "fakepassword",
                            readonly: "",
                            required: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("b-form-text", { staticClass: "text-right link" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  _setup.showPasswordChangeModal = true
                                },
                              },
                            },
                            [_vm._v("Change password")]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _setup.hasAffiliate
          ? _c(
              "div",
              {
                staticClass:
                  "col-6 d-flex flex-wrap justify-content-center mt-3",
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "white-card card-with-input",
                    attrs: { title: "Paypal Account" },
                  },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _setup.onPaypalSubmit()
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "your-paypal-email",
                              label: "Email",
                              "label-for": "your-paypal-email",
                            },
                          },
                          [
                            _c("b-form-input", {
                              staticStyle: { cursor: "text !important" },
                              attrs: {
                                id: "referral-code-input",
                                type: "email",
                                placeholder: "mypaypal@customily.com",
                                required: "",
                              },
                              model: {
                                value: _setup.paypalEmail,
                                callback: function ($$v) {
                                  _setup.paypalEmail = $$v
                                },
                                expression: "paypalEmail",
                              },
                            }),
                            _vm._v(" "),
                            _c("b-form-text", [
                              _vm._v(
                                "\n                            Please add the Paypal email where you'd like to receive payouts.\n                        "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          _setup.LoaderBtn,
                          {
                            staticClass: "float-right",
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              loading: _setup.savingPaypalEmail,
                              disabled: !_setup.modifiedPaypalEmail,
                              "loading-text": "Saving",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Save\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.hasAffiliate
          ? _c(
              "div",
              {
                staticClass:
                  "col-6 d-flex flex-wrap justify-content-center mt-3",
              },
              [
                _c("div", { staticClass: "card white-card card-with-input" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c(
                        "div",
                        { staticClass: "card-title d-flex align-items-center" },
                        [
                          _c("h4", [_vm._v("Referrals")]),
                          _vm._v(" "),
                          _c("b-icon", {
                            directives: [{ name: "tippy", rawName: "v-tippy" }],
                            staticClass: "h6",
                            attrs: {
                              id: "question-circle-icon",
                              content: `Invite your friends to Customily and
                            get a discount for every friend! Learn more about how referrals work
                            <a href=${_setup.helpc} target='_blank'>here</a>`,
                              icon: "question-circle",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "your-referral-code",
                            label: "Share this url to get installs on Shopify",
                            "label-for": "your-referral-code",
                          },
                        },
                        [
                          _c("b-form-input", {
                            staticStyle: { cursor: "text !important" },
                            attrs: {
                              id: "referral-code-input-1",
                              required: "",
                              disabled: "",
                            },
                            model: {
                              value: _setup.myStampUrl,
                              callback: function ($$v) {
                                _setup.myStampUrl = $$v
                              },
                              expression: "myStampUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.showReferralCard && !_setup.hasAffiliate
          ? _c(
              "div",
              {
                staticClass:
                  "col-6 d-flex flex-wrap justify-content-center mt-3",
              },
              [
                _c("div", { staticClass: "card white-card card-with-input" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _c(
                        "h4",
                        [
                          _vm._v(
                            "\n                            Referrals\n                            "
                          ),
                          _c("b-icon", {
                            directives: [{ name: "tippy", rawName: "v-tippy" }],
                            staticClass: "h6",
                            attrs: {
                              content:
                                "Share this URL and invite Shopify stores to install Customily to earn commissions!",
                              icon: "question-circle",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _setup.onReferrerSubmit()
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "your-referral-code",
                              label:
                                "Share this url to get installs on Shopify",
                              "label-for": "your-referral-code",
                            },
                          },
                          [
                            _c("b-form-input", {
                              staticStyle: { cursor: "text !important" },
                              attrs: {
                                id: "referral-code-input-3",
                                required: "",
                                disabled: "",
                              },
                              model: {
                                value: _setup.myReferralCode,
                                callback: function ($$v) {
                                  _setup.myReferralCode = $$v
                                },
                                expression: "myReferralCode",
                              },
                            }),
                            _vm._v(" "),
                            _c("b-form-text", [
                              _vm._v(
                                " " +
                                  _vm._s(_setup.numberReferred) +
                                  " friends used your referral code. "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-modal",
                          {
                            attrs: {
                              title: "Success!",
                              "modal-class": "vue-need-bootstrap",
                              lazy: "",
                              centered: "",
                              "no-close-on-backdrop": "",
                            },
                            on: { ok: _setup.updateUserName },
                            model: {
                              value: _setup.showReferrerSuccess,
                              callback: function ($$v) {
                                _setup.showReferrerSuccess = $$v
                              },
                              expression: "showReferrerSuccess",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            You successfully used a referral code, both you and your friend will receive a discount\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _setup.showReferrerInput
                          ? _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "referrer",
                                  label:
                                    "Enter your friend's code and get a discount",
                                  "label-for": "referrer",
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { id: "referrer" },
                                  model: {
                                    value: _setup.referrer,
                                    callback: function ($$v) {
                                      _setup.referrer = $$v
                                    },
                                    expression: "referrer",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.referrerEmail
                          ? _c("b-form-text", [
                              _vm._v(
                                "\n                            You've used "
                              ),
                              _c("b", [_vm._v(_vm._s(_setup.referrerEmail))]),
                              _vm._v(" code\n                        "),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.referrerErrorMessage
                          ? _c(
                              "div",
                              { staticClass: "invalid-feedback d-block" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_setup.referrerErrorMessage) +
                                    "\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.showReferrerInput
                          ? _c(
                              _setup.LoaderBtn,
                              {
                                staticClass: "float-right",
                                attrs: {
                                  type: "submit",
                                  variant: "primary",
                                  loading: _setup.savingReferrer,
                                  "loading-text": "Saving",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Save\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6 d-flex flex-wrap justify-content-center mt-3" },
          [
            _c(
              "b-card",
              {
                staticClass: "white-card card-with-input",
                staticStyle: { display: "none" },
                attrs: { title: "Security" },
              },
              [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _setup.onSecuritySubmit()
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(_setup.CCheckbox, {
                          attrs: { label: "Clipart protection", switch: "" },
                          model: {
                            value: _setup.clipartProtection,
                            callback: function ($$v) {
                              _setup.clipartProtection = $$v
                            },
                            expression: "clipartProtection",
                          },
                        }),
                        _vm._v(" "),
                        _c("small", { staticClass: "form-text text-muted" }, [
                          _vm._v(
                            "\n                            Clipart protection will only be available for newly created image libraries elements\n                        "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      _setup.LoaderBtn,
                      {
                        staticClass: "float-right",
                        attrs: {
                          type: "submit",
                          variant: "primary",
                          loading: _setup.savingSecurity,
                          disabled: !_setup.modifiedSecurity,
                          "loading-text": "Saving",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Save\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }